import React from "react";
import "./style.css";
import Button from "../CtaButton";
import { useTranslation } from "react-i18next";

const SoftwareCompanyCta = ({ content, customClass }) => {
  return (
    <>
      <div className={`software-company-cta-bg ${customClass}`}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7 col-md-12">
              <h2 className="software-company-cta-title" dangerouslySetInnerHTML={{ __html: content?.heading, }}></h2>
              <p className="software-company-cta-subtitle">
                {content?.subHeading}
              </p>

              <Button
                text={content?.buttonText}
                link={"https://calendly.com/bitsclan-it/30min?"}
                hideIcon={true}
                newTab
              />
            </div>
            <div className="col-lg-5 col-md-12 remove-image-box">
              <div className="software-company-cta-image-wrapper">
                {/* Replace with your image source */}
                <img
                  src={content?.image ?? "/images/why-us-section/bottom-cta.avif"}
                  alt="Two developers collaborating on a laptop"
                  className="software-company-cta-image img-fluid"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SoftwareCompanyCta;
